import { ShortTextInput } from '~/@/components/inputs/text/short-text-input'
import { CustomFilterInputProps } from './CustomFilterInput'

/**
 * Wrapper component for Input specifically for numeric filters
 */
export function CustomNumericFilterInput(props: CustomFilterInputProps) {
  const { item, applyValue, disabled } = props

  return (
    <ShortTextInput
      className="h-[34px] text-xs" // Fixed height to match other filters
      disabled={disabled}
      onChange={(event) => {
        const value = event.target.value === '' ? null : Number(event.target.value)
        applyValue({ ...item, value })
      }}
      type="number"
      value={item.value ?? ''}
    />
  )
}
